import React, { Component } from "react";
import { connect } from "react-redux";

import { lang } from "../../../config/lang";
import blogApi from "../../../api/blogApi";
import { Businesses } from "../../../config/Helper";

/****************************************
    Component for Category Box on Blog List Page
    @author  IMH003
    @date    2020.05.14
    @version 0.1    
 ******************************************/
class SideCategoryBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeCate: parseInt(this.props.activeBusiness, 10),
      activeSub: 0,
      arrCategory: [],
    };

    this.getCategories = this.getCategories.bind(this);
    this.onCategory = this.onCategory.bind(this);
  }

  componentWillMount() {}

  componentDidMount() {
    this.getCategories();
  }

  componentWillUnmount() {}

  componentWillReceiveProps(newProps) {
    this.getCategories();
  }

  getCategories() {
    blogApi.getCategories().then((json) => {
      if (json.status === 200 && json.data) {
        var categories = [];
        var total_count = 0;
        json.data.forEach((category) => {
          categories.push({
            id: Businesses.indexOf(category.business),
            title: category.business,
            count: category.count,
            sub: category.sub,
          });
          total_count += category.count;
        });

        categories.splice(0, 0, { id: -1, title: "all", count: total_count });
        this.setState({
          arrCategory: categories,
        });
      } else if (json.status !== 200) {
      }
    });
  }

  onCategory(businessId, subId) {
    this.setState({
      activeCate: businessId,
      activeSub: subId,
    });
    this.props.onCategory(businessId, subId);
  }

  render() {
    return (
      <div className="side-box">
        <h2 className="heading">{this.props.title}</h2>
        <ul className="post-categories list-unstyled">
          {this.state.arrCategory.map((category, key) => (
            <li key={key}>
              <a
                className={`${
                  this.state.activeCate === category.id &&
                  this.state.activeSub === 0
                    ? "active"
                    : ""
                }`}
                onClick={() => this.onCategory(category.id, 0)}
              >
                {lang(category.title)}{" "}
                <span className="count">{`(${category.count})`}</span>
              </a>
              {category.sub !== undefined && category.sub !== null && (
                <ul className="list-unstyled">
                  {category.sub.map(
                    (sub, key) =>
                      sub.id !== 0 && (
                        <li key={key}>
                          <a
                            className={`${
                              this.state.activeSub === sub.id ? "active" : ""
                            }`}
                            onClick={() => this.onCategory(category.id, sub.id)}
                          >
                            <i className="fa fa-play" aria-hidden="true"></i>
                            {sub.title}{" "}
                            <span className="count">{`(${sub.count})`}</span>
                          </a>
                        </li>
                      )
                  )}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.language,
  };
}

export default connect(mapStateToProps)(SideCategoryBox);
